import React, { useState, useEffect } from "react"
import {
  Typography,
  Input,
  Box,
  FormControl,
  InputLabel,
  Chip,
  IconButton
} from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import MaskedHashtagInput from "../MaskedHashtagInput"
import CancelIcon from "@material-ui/icons/Cancel"
import { updateOrganization } from "actions/organization"
import { useDispatch, useSelector } from "react-redux"

const HashtagSchema = Yup.object().shape({
  hashtag: Yup.string().required()
})

const Hashtags = ({ classes, hashtags: orgHashtags }) => {
  const dispatch = useDispatch()
  const [hashtags, setHashtags] = useState([])
  const org = useSelector(state => state.organization)

  const handleCancel = i => {
    const newHashtags = hashtags.filter(element => element !== hashtags[i])
    setHashtags(newHashtags)
    dispatch(updateOrganization({ hashtags: newHashtags }, org.currentOrg.id))
  }

  const handleAdd = hashtag => {
    const newHashtags = [...hashtags, hashtag]
    setHashtags(newHashtags)
    dispatch(updateOrganization({ hashtags: newHashtags }, org.currentOrg.id))
  }

  useEffect(() => {
    if (orgHashtags && orgHashtags.split(",").length > 0) {
      setHashtags(orgHashtags.split(","))
    }
  }, [orgHashtags])

  return (
    <Box>
      <Formik
        initialValues={{ hashtag: "" }}
        validationSchema={HashtagSchema}
        onSubmit={(values, { resetForm }) => {
          handleAdd(values.hashtag)
          resetForm()
          document.getElementById("hashtag").focus()
        }}
      >
        {({ values, handleChange, handleBlur }) => (
          <Form id="submitHashtagForm">
            <Box className={classes.hashtagsContainer}>
              <FormControl
                // error={errors.hashtag && touched.hashtag}
                className={classes.hashtagsContainer}
              >
                <Box display="flex">
                  <Box>
                    <InputLabel htmlFor="hashtag">
                      <Typography variant="h5" className={classes.hashtagTitle}>
                        Write a hashtag
                      </Typography>
                    </InputLabel>
                    <Input
                      name="hashtag"
                      id="hashtag"
                      value={values.hashtag}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      inputComponent={MaskedHashtagInput}
                    />
                    {/* <FormHelperText className={classes.errorContainer}>
                      {touched.hashtag && errors.hashtag}
                    </FormHelperText> */}

                    <IconButton
                      id="submitHashtagForm"
                      className={classes.addButton}
                      type="submit"
                      disabled={values.hashtag === ""}
                    >
                      <AddCircleRoundedIcon
                        color="secondary"
                        className={
                          values.hashtag === ""
                            ? classes.addDisabled
                            : classes.add
                        }
                      />
                    </IconButton>
                  </Box>
                </Box>
              </FormControl>
            </Box>
          </Form>
        )}
      </Formik>
      <Box>
        {hashtags.map((hashtag, i) => (
          <Chip
            key={i}
            className={classes.hashtagContainer}
            size="small"
            label={hashtag}
            icon={<CancelIcon onClick={() => handleCancel(i)} />}
            color="secondary"
            classes={{
              labelSmall: classes.labelSmallExtra
            }}
          />
        ))}
      </Box>
    </Box>
  )
}

export default withStyles(styles)(Hashtags)



// WEBPACK FOOTER //
// ./src/components/Hashtags/index.jsx